import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DeleteButton from "../common/DeleteButton";
import ThreeDot from "../common/ThreeDot";
import ViewDetailsButton from "../common/ViewDetailsButton";
import { deleteCoupon, getAllCoupons } from "../../services/coupon.service";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import EditButton from "../common/EditButton";

export default function Coupons() {
  const { token } = useSelector((state) => state?.auth);
  const [coupons, setCoupons] = useState([]);

  const handleDelete = async (couponId) => {
    try {
      const res = await deleteCoupon(token, couponId);

      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire({
          title: "Deleted!",
          text: `Coupon has been deleted successfully.`,
          icon: "success",
        }).then(() => {
          fetchCoupons();
        });
      } else {
        Swal.fire(
          "Error",
          res?.data?.detail || "Failed to delete the coupon. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during coupon deletion:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  const fetchCoupons = async () => {
    try {
      const res = await getAllCoupons(token);
      if (res && res.status >= 200 && res.status < 300) {
        setCoupons(res?.data);
        // console.log(res?.data);
      } else {
        Swal.fire(
          "Error",
          res?.data?.message || "Failed to fetch brands. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching brands:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    fetchCoupons();
  }, []);

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="form-head d-flex mb-3 align-items-start justify-content-between">
          <h2 className="page-title mt-4"></h2>

          <div style={{ zIndex: 2 }}>
            <Link to="/coupons/add">
              <button className="btn btn-primary px-3 py-2 add-btn sticky-btn">
                Add
                <img
                  className="plus-sign ms-2"
                  src="/assets/images/kidskart/icon/add.png"
                />
              </button>
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12 col-xxl-12 col-lg-12 col-sm-12 mt-4">
            <div className="card">
              <div className="card-body p-0 ">
                {coupons && coupons.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table order-request2">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Code</th>
                          <th>Discount</th>
                          <th>Min Amt</th>
                          <th>Max Allowed</th>
                          <th>Used Code(s)</th>
                          <th>Expiry Date</th>
                          {/* <th>Created On</th> */}
                          <th>Status</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {coupons?.length > 0 &&
                          coupons.map((item, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{item.coupon_code}</td>
                              <td>
                                {item.coupon_type === "Percentage"
                                  ? item.coupon_percent + "%"
                                  : "₹" + (item.coupon_amount * 1)?.toLocaleString(
                                    "en-IN",
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}
                              </td>
                              <td>₹{(item.min_applicable_amount * 1)?.toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}</td>
                              <td>{item.max_allowed_coupon}</td>
                              <td>{item.used_coupons}</td>
                              <td>
                                {new Date(item?.expiry_date)
                                  .toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric",
                                  })
                                  .replace(" ", " ")
                                  .replace(/(\w+ \w+)/, "$1,")}
                              </td>
                              {/* <td>Oct 30, 2024</td> */}
                              <td>
                                <Link
                                  className={`btn ${
                                    item.status ? "btn-success" : "btn-danger"
                                  } light btn-sm`}
                                >
                                  {item.status ? "ACTIVE" : "EXPIRED"}
                                </Link>
                              </td>
                              <td>
                                <div className="dropdown ms-auto c-pointer">
                                  <ThreeDot />
                                  <div className="dropdown-menu dropdown-menu-end">
                                    <EditButton
                                      to={`/coupons/update/`}
                                      id={item.coupon_id}
                                    />
                                    <DeleteButton
                                      name="Coupon"
                                      onDelete={() =>
                                        handleDelete(item.coupon_id)
                                      }
                                    />
                                    <ViewDetailsButton
                                      to={`/coupons/details`}
                                      id={item.coupon_id}
                                    />
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                        {coupons && coupons.length < 5 ? (
                          <tr style={{ height: "205px" }}></tr>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="my-5 py-5 text-center fs-4 fw-bold">
                    Please Add Coupon
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
